import React from 'react';
import { Row, Col } from 'antd';
import Link from 'next/link';
import { Title, Text, Category } from 'components/Card';
import WhitePaperImage from 'components/WhitePaperImage';

interface Props {
    $whitePaper: WhitePaper;
}

const WhitePaperItem = ({
    $whitePaper: { seoSlug, openingImage, content, title }
}: Props): JSX.Element => (
    <Row gutter={16}>
        <Col span={8}>
            <Link href={`/white-papers/${seoSlug}`}>
                <WhitePaperImage openingImage={openingImage} title={title} />
            </Link>
        </Col>
        <Col span={16}>
            <Category>
                <Link href="/white-papers">Do Pobrania</Link>
            </Category>
            <Title>
                <Link href={`/white-papers/${seoSlug}`}>{title}</Link>
            </Title>
            {content && (
                <Text>
                    <Link href={`/white-papers/${seoSlug}`}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: content
                            }}
                        />
                    </Link>
                </Text>
            )}
        </Col>
    </Row>
);

export default WhitePaperItem;
